import React, { useContext } from 'react'
import RepartitionChart from '@/app/modules/p2c/reports/customer/charts/RepartitionChart'
import VisitorEvolutionChart from '@/app/modules/p2c/reports/customer/charts/VisitorEvolutionChart'
import ActiveEvolutionChart from '@/app/modules/p2c/reports/customer/charts/ActiveEvolutionChart'
import IndicatorsGroup from '../Indicators'
import { Card } from '@/components/Card'
import { DateRangeContext } from '@/components/context/DateRangeContext'
import {
  getActiveRepartition,
  getVisitorsRepartition,
  getEmailsRepartition,
  getRefererRepartition
} from '@/app/modules/p2c/reports/customer/core/_requests'

const OrderReportPane = () => {
  const { from, to, timezone } = useContext(DateRangeContext)

  return (
    <>
      <div className="row">
        <div className="col-xl-4">
          <RepartitionChart
            title="Visitors"
            showTotal={true}
            translate={true}
            dataProvider={() => getVisitorsRepartition({ from, to, timezone })}
            from={from}
            to={to}
            height={200}
          />
        </div>

        <div className="col-xl-4">
          <RepartitionChart
            title="New customers"
            showTotal={true}
            translate={true}
            dataProvider={() => getActiveRepartition({ from, to, timezone, _new: true })}
            from={from}
            to={to}
            height={200}
          />
        </div>

        <div className="col-xl-4">
          <RepartitionChart
            title="Returning customers"
            showTotal={true}
            translate={true}
            dataProvider={() => getActiveRepartition({ from, to, timezone, _new: false })}
            from={from}
            to={to}
            height={200}
          />
        </div>
      </div>

      <IndicatorsGroup from={from} to={to} timezone={timezone} />

      <div className="row">
        <div className="col-xl-4">
          <RepartitionChart
            title="Registration referer"
            translate={false}
            dataProvider={async () => {
              return getRefererRepartition({ from, to, timezone }).then(data => {
                const limit = 6

                if (data.length <= limit) {
                  return data
                }

                const firstFour = data.slice(0, limit)
                const othersValue = data.slice(limit).reduce((sum, item) => sum + item.value, 0)
                const others = { _id: "others", value: othersValue }
                return [...firstFour, others]
              })
            }}
            from={from}
            to={to}
            height={200}
          />

          <div className="card mb-5 mb-xl-10">
            <RepartitionChart
              title="Registration domain"
              translate={false}
              dataProvider={async () => {
                return getEmailsRepartition({ from, to, timezone }).then(data => {
                  const limit = 6
                  const firstFour = data.slice(0, limit)
                  const othersValue = data.slice(limit).reduce((sum, item) => sum + item.value, 0)
                  const others = { _id: "others", value: othersValue }
                  return [...firstFour, others]
                })
              }}
              from={from}
              to={to}
              height={200}
            />
          </div>
        </div>
        <div className="col-xl-8">
          <Card
            title="Customers evolution"
            collapsable={false}
          >
            <VisitorEvolutionChart
              from={from}
              to={to}
              timezone={timezone}
              height={350}
            />

            <ActiveEvolutionChart
              from={from}
              to={to}
              timezone={timezone}
              height={150}
            />
          </Card>
        </div>
      </div>
    </>
  )
}

export default OrderReportPane
